export enum NeloLogLevel {
    Fatal = 'FATAL',
    Error = 'ERROR',
    Warn = 'WARN',
    Info = 'INFO',
    Debug = 'DEBUG',
    /**
     * myasset custom nelo log level
     */
    Client = 'CLIENT',
    Gssp = 'GSSP',
    Server = 'SEVER',
}
